module.exports = __webpack_public_path__ + "img/image (3).c5bc4b47.jpg";